import { render, staticRenderFns } from "./FooterTheme.vue?vue&type=template&id=a2b4c4c4"
import script from "./FooterTheme.vue?vue&type=script&lang=js"
export * from "./FooterTheme.vue?vue&type=script&lang=js"
import style0 from "./FooterTheme.vue?vue&type=style&index=0&id=a2b4c4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports